/* eslint-disable zeffy-linter-frontend/no-classname-prop -- legacy baseline (pre-rule); remove when these are migrated */
import Grid from "@mui/material/Grid";

import { useTranslate } from "../../../../common/hooks/useTranslate";
import { MethodsSection } from "../../TwoFactorSetupContent/MethodsSection/MethodsSection";
import { Mandatory2FAStepLayout } from "../Mandatory2FAStepLayout/Mandatory2FAStepLayout";

import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { MfaLock } from "@/icons/illustration";

interface IntroductionStepProps {
  onSetupSms: () => void;
  onSetupTotp: () => void;
}

export const IntroductionStep = ({ onSetupSms, onSetupTotp }: IntroductionStepProps) => {
  const { t } = useTranslate();

  return (
    <Mandatory2FAStepLayout>
      <Grid item xs={12}>
        <MfaLock className="svg-safari-fix" width={100} height={100} />
      </Grid>
      <Grid item xs={12}>
        <DashboardTypography variant="h6">{t("dashboard", "mandatory2FA.introduction.title")}</DashboardTypography>
      </Grid>
      <Grid item xs={12}>
        <DashboardTypography variant="body2">
          {t("dashboard", "mandatory2FA.introduction.description1")}
        </DashboardTypography>
      </Grid>
      <Grid item xs={12}>
        <DashboardTypography variant="body2">
          {t("dashboard", "mandatory2FA.introduction.description2")}
        </DashboardTypography>
      </Grid>
      <Grid item xs={12}>
        <DashboardTypography variant="body2" vibe="text-neutral-quiet">
          {t("dashboard", "mandatory2FA.introduction.mandatory")}
        </DashboardTypography>
      </Grid>
      <Grid item xs={12}>
        <MethodsSection onActivateTotp={onSetupTotp} onActivateSms={onSetupSms} onEditPhoneNumber={() => {}} />
      </Grid>
    </Mandatory2FAStepLayout>
  );
};
